enum ModalTypes {
    PAIRING_GUIDE_ERROR,
    PAIRING_SKIP,
    REGISTRATION_FAILED,
    HID_RECONNECT,
    DEVICE_IS_IN_SBL,
    RECONNECT_DEVICE_GUIDE,
    FIRMWARE_RELEASE_NOTES_POPUP,
    FWU_LED_CHECK,
    FWU_ADDITIONAL_STEPS_GUIDE,
    FWU_ERROR,
    REGISTRATION_HOLDER,
    PURCHASE_DATE,
    DEVICE_LOCKED,
    USB_REQUIRED,
    MANUAL_REGISTRATION,
    UWM_UNAVAILABILITY,
    OUTSIDE_REGISTRATION,
    OUTSIDE_CLICK_POPUP,
    LOYALTY_CLUB,
    PAUSE_MODE,
    LEVIA_LEAR_MORE,
    LEVIA_FWU,
    QUICK_START_GUIDE_POPUP,
    CONSUMER_FEEDBACK_GATHERING,
}

export default ModalTypes;
